import { render, staticRenderFns } from "./SolveSection.vue?vue&type=template&id=b1d68c70&scoped=true&"
import script from "./SolveSection.vue?vue&type=script&lang=js&"
export * from "./SolveSection.vue?vue&type=script&lang=js&"
import style0 from "./SolveSection.vue?vue&type=style&index=0&id=b1d68c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d68c70",
  null
  
)

export default component.exports